import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGradient16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconGradient16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.414 3H7L2 8V6.405l.06-.051zM4 3 2 5V4a1 1 0 0 1 1-1zm1.207-1H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.207 11H13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8.005a.5.5 0 0 1-.116.525L2.061 9.354 2 9.405V11l5.182-5.182a.5.5 0 0 1 .707.707l-5.826 5.826A1 1 0 0 0 3 13l4.182-4.182a.5.5 0 0 1 .707.707L4.414 13H6l1.182-1.182a.5.5 0 0 1 .707.707z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGradient16);
